module.exports = __webpack_public_path__ + "img/ar.5d8bdfb3.png";